<div
    class="inner-content dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black"
    ridangoAppTrapFocus>
    <div class="relative">
        <div class="flex-align-center m-4 !flex justify-center">
            <p class="var-app-light-dark:font-bold orb-app-light-dark:font-bold font-semibold">
                {{ 'EDIT_FAVORITES_JOURNEYS' | translate }}
            </p>
            <button
                class="close-icon"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon
                    class="var-app-light:text-grey-zambezy var-app-light-dark:text-[2rem] orb-app-light:text-grey-zambezy orb-app-light-dark:text-[2rem]"
                    >close</mat-icon
                >
            </button>
        </div>
    </div>
    <div class="border-ironside_grey-100 !flex border-t border-solid dark:border-contrast-yellow"></div>
    <ng-container>
        <rwidget-journey-planner-favorite-list
            class="block h-3/5 overflow-y-auto"
            [isShowHeader]="false"
            [isShowLocationRemoveIcon]="true"
            (removedLocations)="handleRemoveFavorite($event)"></rwidget-journey-planner-favorite-list>
    </ng-container>
    <div class="border-ironside_grey-100 !flex border-t border-solid dark:border-contrast-yellow"></div>
    <div class="m-4 !flex">
        <ng-container>
            <button
                class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-black var-app-light:font-semibold orb-app-light:text-black orb-app-light:bg-primary orb-app-light-dark:font-semibold h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                (click)="handleSaveClick()">
                {{ 'SAVE' | translate }}
            </button>
        </ng-container>
    </div>
</div>
